export const SALES_SLUG = 'lead-overview-call';
export const FREE_TRIAL_EVENT_PATH = '----542/bambee-overview-call';

export const CallKinds = Object.freeze({
  OVERVIEW_CALL: 'overview-call',
  ESSENTIAL_UPGRADE: 'essential-upgrade',
  HR_TRANSITION_INTRO: 'hr-transition-intro',
  SELF_SERVICE_HR_STRATEGY: 'self-service-hr-strategy',
});

export const DEFAULT_CALL_KIND = CallKinds.OVERVIEW_CALL;

export default {
  CallKinds,
  DEFAULT_CALL_KIND,
  FREE_TRIAL_EVENT_PATH,
  SALES_SLUG,
};
